import { render, staticRenderFns } from "./RouterLink_Default.vue?vue&type=template&id=34ecac96&"
import script from "./RouterLink_Default.vue?vue&type=script&lang=js&"
export * from "./RouterLink_Default.vue?vue&type=script&lang=js&"
import style0 from "./RouterLink_Default.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports